import React, { useEffect, useMemo, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { catchAsync, checkResponse } from "../../../../../utilities/utilities";
import {
  GET_JOB_BY_ID,
  UPDATE_JOB,
  ADD_JOB,
} from "../../../../../services/ApiCalls";
import Loader from "../../../../../components/Common/Loader";
import Loading from "../../../../../components/Common/Loading";
import moment from "moment";
import GoogleAutocomplete from "../../../../../components/Common/GoogleAutoComplete";

const jobSchema = z.object({
  title: z.string().min(1, "Job Title is required"),
  description: z.string().min(1, "Description is required"),
  location: z.string().min(1, "Location is required"),
  dateTime: z.string().min(1, "Date & Time is required"),
  // eventType: z.string().min(1, "Job Type is required"),
  // postedAt: z.string().min(1, "Posted At date is required"),
});

const EditJobPost = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [jobDetails, setJobDetails] = useState(null);

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    watch,
  } = useForm({
    resolver: zodResolver(jobSchema),
    defaultValues: {
      title: "",
      description: "",
      location: "",
      dateTime: "",
      price: "",
      postedAt: "",
      lat: "",
      lng: "",
    },
  });

  const getJobData = catchAsync(async () => {
    setLoader(true);
    const res = await GET_JOB_BY_ID(id);
    const success = checkResponse({
      res,
      setData: setJobDetails,
      setLoader,
    });
    if (success) {
      const data = res.data.data;
      setValue("title", data.title);
      setValue("description", data.description);
      setValue("price", data.price);
      setValue("location", data.postLocation?.address);
      setValue("lat", data.postLocation?.location?.coordinates?.[1]);
      setValue("lng", data.postLocation?.location?.coordinates?.[0]);

      setValue("dateTime", moment(data.eventDate).format("YYYY-MM-DDTHH:mm"));
      // setValue("dateTime", data.eventDate);

      // setValue("eventType", data.eventType);
      // setValue("postedAt", data.postedAt);
    }
  }, setLoader);

  useEffect(() => {
    if (id) getJobData();
  }, [id]);
  const addressChangeHandler = (address) => {
    setValue("location", address?.address, { shouldValidate: true });
    setValue("lat", address?.lat, { shouldValidate: true });
    setValue("lng", address?.lng, { shouldValidate: true });
  };

  const submitHandler = catchAsync(async (data) => {
    const body = {
      ...data,
      postLocation: {
        address: data?.location,
        lat: data?.lat,
        lng: data?.lng,
      },

      ...(id && { _id: id }),
    };

    const res = await (id && UPDATE_JOB(body));
    const success = checkResponse({ res, showSuccess: true });

    if (success) {
      navigate(-1);
    }
  });
  console.log("error", errors);
  return (
    <>
      {loader && <Loader />}
      <section className="editUser position-relative py-3">
        <Container>
          <Row>
            <Col lg="12">
              <div className="d-flex align-items-center gap-10">
                <Button
                  onClick={() => navigate(-1)}
                  variant="outline-secondary"
                  className="border d-flex align-items-center p-2 rounded"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="12"
                    viewBox="0 0 10 16"
                    fill="none"
                  >
                    <path
                      d="M8.64707 0.473344C8.55514 0.381188 8.44594 0.308072 8.32572 0.258184C8.20549 0.208296 8.07661 0.182617 7.94644 0.182617C7.81628 0.182617 7.68739 0.208296 7.56717 0.258184C7.44694 0.308072 7.33774 0.381188 7.24582 0.473344L0.667065 7.05209C0.593675 7.12533 0.53545 7.21233 0.495723 7.3081C0.455996 7.40387 0.435547 7.50654 0.435547 7.61022C0.435547 7.7139 0.455996 7.81657 0.495723 7.91234C0.53545 8.00811 0.593675 8.0951 0.667065 8.16834L7.24582 14.7471C7.63373 15.135 8.25915 15.135 8.64707 14.7471C9.03498 14.3592 9.03498 13.7338 8.64707 13.3458L2.9154 7.60626L8.65498 1.86668C9.03498 1.48668 9.03498 0.853344 8.64707 0.473344Z"
                      fill="#fff"
                      stroke="#1E232C"
                      strokeWidth="0.2"
                    />
                  </svg>
                </Button>
                <h4 className="mb-0 py-3 fw-bold text-dark text-capitalize">
                  {id ? "Edit" : "Add"} Post
                </h4>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <div
                className="formWrpper px-lg-5 p-md-4 p-3 rounded"
                style={{ background: "#EEEEEE" }}
              >
                <Form onSubmit={handleSubmit(submitHandler)}>
                  <Row>
                    <Col lg="6" className="my-2">
                      <label className="form-label">Title</label>
                      <input
                        className="form-control"
                        {...register("title")}
                        placeholder="Enter job title"
                      />
                      {errors.title && (
                        <p className="text-danger">{errors.title.message}</p>
                      )}
                    </Col>
                    <Col lg="6" className="my-2">
                      <label className="form-label">Price</label>
                      <input
                        className="form-control"
                        {...register("price")}
                        placeholder="Enter Price"
                      />
                      {errors.price && (
                        <p className="text-danger">{errors.price.message}</p>
                      )}
                    </Col>

                    {/* <Col lg="6" className="my-2">
                      <label className="form-label">Job Type</label>
                      <select
                        className="form-control"
                        {...register("eventType")}
                        defaultValue=""
                      >
                        <option value="" disabled>
                          Select Job Type
                        </option>
                        <option value="Unpaid_Artist">Unpaid Artist</option>
                        <option value="Paid_Artist">Paid Artist</option>
                      </select>
                      {errors.eventType && (
                        <p className="text-danger">
                          {errors.eventType.message}
                        </p>
                      )}
                    </Col> */}

                    <Col lg="12" className="my-2">
                      <label className="form-label">Description</label>
                      <textarea
                        className="form-control"
                        rows={4}
                        {...register("description")}
                        placeholder="Job description..."
                      />
                      {errors.description && (
                        <p className="text-danger">
                          {errors.description.message}
                        </p>
                      )}
                    </Col>

                    <Col lg="6" className="my-2">
                      <label className="form-label">Location</label>
                      <GoogleAutocomplete
                        lat={watch("lat")}
                        lng={watch("lng")}
                        name={"location"}
                        address={watch("location")}
                        onChange={addressChangeHandler}
                      />
                      {errors?.location && (
                        <p className="text-danger m-0">
                          {errors?.location?.message}
                        </p>
                      )}
                    </Col>

                    <Col lg="6" className="my-2">
                      <label className="form-label">Date & Time</label>
                      <input
                        type="datetime-local"
                        className="form-control"
                        {...register("dateTime")}
                      />
                      {errors.dateTime && (
                        <p className="text-danger">{errors.dateTime.message}</p>
                      )}
                    </Col>

                    <Col
                      lg="12"
                      className="my-4 d-flex justify-content-center gap-3"
                    >
                      <Button
                        onClick={() => navigate(-1)}
                        className="commonBtn GreyBtn"
                      >
                        Back
                      </Button>

                      <Button type="submit" className="commonBtn">
                        Submit
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default EditJobPost;
